import { lt, useDialog } from '@mews/framework';
import { DropDownButton, DropdownItem, Icon, IconName } from '@optimus-web/core';
import { EnterpriseLink } from '@mews-commander/ui';
import { DeleteDialog } from '../../../common/DeleteDialog';
import { useDeleteTemplateMutation } from '../hooks/useDeleteTemplateMutation';

export const ActionCell = ({ templateId }: { templateId: string }) => {
    const [{ onClose: onDeleteDialogClose, active: isDeleteDialogActive }, openDeleteDialog] = useDialog();
    const { mutate: deleteTemplate, isPending: isTemplateDeletePending } = useDeleteTemplateMutation();

    return (
        <>
            <DropDownButton icon={IconName.More} size="small" variant="ghost">
                <EnterpriseLink
                    params={{ id: templateId }}
                    standalone
                    to="Settings/ReservationContracts/Template/$id"
                    underline={false}
                    variant="basic"
                >
                    <DropdownItem label={lt('Edit')} leftDetail={<Icon value={IconName.Edit} size="small" />} />
                </EnterpriseLink>
                <DropdownItem
                    label={lt('Delete')}
                    leftDetail={<Icon value={IconName.Delete} size="small" />}
                    onClick={() => openDeleteDialog()}
                />
            </DropDownButton>
            <DeleteDialog
                isActive={isDeleteDialogActive}
                onClose={onDeleteDialogClose}
                title={lt('ContractTemplateDeleteConfirmationTitle')}
                description={lt('ContractTemplateDeleteConfirmationDescription')}
                onDelete={() => deleteTemplate({ id: templateId }, { onSuccess: onDeleteDialogClose })}
                loading={isTemplateDeletePending}
            />
        </>
    );
};
